export default __webpack_public_path__ + "assets/5fa82d6c4d534de71fb29c0dbbc01053.jpeg";